/**
 * ToastContainer - Renders all active toasts
 * 
 * Uses React Portal to render toasts at the root level
 * Supports different positions (top-left, top-right, bottom-left, bottom-right)
 */

import { createPortal } from 'react-dom';
import { useToast } from '../../context/ToastContext';
import Toast from './Toast';
import './ToastContainer.css';

const ToastContainer = () => {
  const { toasts, dismissToast } = useToast();

  // Group toasts by position
  const toastsByPosition = toasts.reduce((acc, toast) => {
    const position = toast.position || 'top-left';
    if (!acc[position]) {
      acc[position] = [];
    }
    acc[position].push(toast);
    return acc;
  }, {});

  const containers = Object.entries(toastsByPosition).map(([position, positionToasts]) => (
    <div key={position} className={`toast-container toast-container-${position}`}>
      {positionToasts.map((toast) => (
        <Toast
          key={toast.id}
          id={toast.id}
          type={toast.type}
          title={toast.title}
          message={toast.message}
          actions={toast.actions}
          countdown={toast.countdown}
          position={toast.position}
          showCloseButton={toast.showCloseButton}
          onDismiss={() => dismissToast(toast.id)}
        />
      ))}
    </div>
  ));

  // Render toasts using portal
  return createPortal(
    <div className="toast-portal">
      {containers}
    </div>,
    document.body,
  );
};

export default ToastContainer;
